<script>
    import FooterSection from '../../../components/pagesbuilder/sections/FooterSection.vue';
    import PreviewSection from "../PreviewSection";

    export default {
        name: "PreviewFooterSection",
        mixins: [PreviewSection,FooterSection],
        data() {
            return {}
        },
    }
</script>
